export default {
    baseUrl:{
        //开发环境
        dev:'/api/',
        //生产环境
        pro:''
    },
    devtool: 'source-map',
}